import { EditorInput, EditorInputProps } from "../editor/editor-input";
import { Field, FieldDescription, FieldLabel } from "../ui/field";
import { FieldErrors, FieldProps } from "./field";
import { useFieldErrors } from "@/shared/lib/errors/err-validation-failed-context";

export function EditorInputField({
  label,
  description,
  errors: ownErrors,
  fieldName,
  fieldProps,
  debounce = true,
  onHtmlChange,
  ...props
}: EditorInputProps & FieldProps) {
  const { errors, invalid, reset } = useFieldErrors(fieldName, ownErrors);

  return (
    <Field data-invalid={invalid || undefined} {...fieldProps}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <EditorInput
        invalid={invalid}
        debounce={debounce}
        {...props}
        onHtmlChange={(html) => {
          reset();
          onHtmlChange(html);
        }}
      />
      {description && <FieldDescription>{description}</FieldDescription>}
      <FieldErrors errors={errors} />
    </Field>
  );
}
